<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="automationId" [isPrimaryButtonHidden]="true"
    (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage"
    [modalHelpIndex]="modalHelpIndex">
<div class="project-access-history" [attr.data-automation-id]="automationId + '-container'">
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [columnDefs]="columnDefs" [cellClickedCallback]="cellClickedCallback"
        [headerTemplate]="reviewImportTrackingHeaderTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
        [requestInfo]="requestInfo" [responseCallback]="responseCallback" [contextMenuOptions]="contextMenuOptions"> 
    </res-generic-grid>

    <ng-template #reviewImportTrackingHeaderTemplate>
        <div class='top-bar'>
            <span class="title">Review Promotion Tracking</span>
            <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
                (click)="openHelp()">
                <i class="fa fa-question"></i>
            </button>
        </div>
    </ng-template>
    <a download #downloadLink hidden target="_blank"></a>
</div>
</res-base-modal>
